import { Typography, Divider, Grid } from "@mui/material";
import TimeZoneInput from "./time-zone-input";
import { useLocalStorage } from "usehooks-ts";
import { handleSetTimeZone } from "./time-zone-input/helper";
import { useSnackbar } from "notistack";

export default function Settings() {
  const [timeZone, setTimeZone] = useLocalStorage<string>('timezone', `Asia/Kolkata`)
  const { enqueueSnackbar } = useSnackbar()
  return (
    <Grid container>
      <Grid item xs={6}>
        <div>
          <Typography sx={{ fontWeight: "medium", fontSize: "16px" }}>
            Account
          </Typography>
          <Typography sx={{ fontSize: "12px" }}>
            Update your account settings. Set your preferred timezone.
          </Typography>
        </div>
        <Divider sx={{ my: 2 }} />

        <TimeZoneInput timeZone={timeZone} handleSetTimeZone={(timeZoneLocal: string) => handleSetTimeZone(timeZoneLocal, enqueueSnackbar, setTimeZone)} />
      </Grid>
    </Grid>
  );
}
